import {Types} from "../../../../type/Types";

export type PlacePathJointEventValueObject = {
    id: bigint
    placePathJointId: bigint | null
    userId: bigint | null
    eventType: string
    misc: string
    createdAt: Date
}

export namespace PlacePathJointEventValueObject {
    export function construct(o: any): PlacePathJointEventValueObject {
        return {
            id: BigInt(o.id),
            placePathJointId: Types.asNull(o.placePathJointId, BigInt),
            userId: Types.asNull(o.userId, BigInt),
            eventType: String(o.eventType),
            misc: String(o.misc),
            createdAt: new Date(o.createdAt),
        }
    }

    export const description: Record<keyof PlacePathJointEventValueObject, string> = {
        id: 'ID',
        placePathJointId: '플레이스 경로 Joint ID',
        userId: '사용자 ID',
        eventType: '이벤트 타입',
        misc: 'misc',
        createdAt: '생성 시각',
    }
}